<template>
  <div>
    <div class="con">
      <div class="title">
        您的
        <a href="javascript:;">用户地址</a>
        有误或
        <a href="javascript:;">未授权</a>
        <br />请联系管理员
      </div>
      <img :src="require('../assets/404.gif')" alt />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.con {
  width: 100%;
  background: #e8e8e8;
  height: 800px;
}
.con > img {
  margin-top: 120px;
}
.title {
  font-size: 16px;
  text-align: center;
  background: #e8e8e8;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  color: #666;
  margin-top: 520px;
  font-family: fantasy;
  height: 40px;
}
</style>